import React from "react";
import { Text, type TextProps } from "@chakra-ui/react";
import { useColorTheme } from "contexts/color-theme";

export function NavColumnLabel({ children, ...props }: TextProps) {
  const { theme } = useColorTheme();
  return (
    <Text textStyle="overline2" color={`brand.textTertiary.${theme}`} mb="small" ml="smaller" {...props}>
      {children}
    </Text>
  );
}
